import React from 'react';
import { Card, Avatar, Tag, Typography } from 'antd';
import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { User, EmploymentType } from '../../../../types/user.types';
import { getFileUrl } from '../../../../utils/file.utils';

const { Title, Text } = Typography;

interface UserSelectionCardProps {
  user: User;
  onSelect: (user: User) => void;
}

const UserSelectionCard: React.FC<UserSelectionCardProps> = ({ user, onSelect }) => {
  const isFieldWorker = user.employeeType === EmploymentType.FIELD;
  const hasProfilePicture = user.profilePicture && user.profilePicture.trim() !== '';
  console.log(user);
  // Cinsiyete göre varsayılan avatar
  const getDefaultAvatar = () => {
    if (hasProfilePicture) return getFileUrl(user.profilePicture);
    if (user.gender === 'male') return '/assets/img/man.png';
    if (user.gender === 'female') return '/assets/img/woman.png';
    return undefined;
  };

  const defaultAvatar = getDefaultAvatar();

  return (
    <Card
      hoverable
      onClick={() => onSelect(user)}
      style={{
        height: '100%',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
      }}
      styles={{
        body: {
          padding: '24px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }}
    >
      <Avatar
        size={80}
        src={defaultAvatar}
        icon={!defaultAvatar ? <UserOutlined /> : undefined}
        style={{
          backgroundColor: defaultAvatar ? '#f0f0f0' : (isFieldWorker ? '#1890ff' : '#52c41a'),
          fontSize: '32px',
          marginBottom: '16px'
        }}
      >
        {!defaultAvatar && `${user.firstName[0]}${user.lastName[0]}`}
      </Avatar>
      <Title level={5} style={{ marginBottom: '8px', marginTop: 0 }}>
        {user.firstName} {user.lastName}
      </Title>
      <Text type="secondary" style={{ marginBottom: '8px' }}>
        {user.email}
      </Text>
      <Tag color={isFieldWorker ? 'blue' : 'green'} style={{ marginTop: '8px' }}>
        {isFieldWorker ? (
          <><EnvironmentOutlined /> Saha Çalışanı</>
        ) : (
          <><UserOutlined /> Ofis Çalışanı</>
        )}
      </Tag>
    </Card>
  );
};

export default UserSelectionCard;

